import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  AdminItemListResponse,
  AdminItemStatus,
} from '@/api/istaff/adminItems';
import type { AdminItemsState } from './types';

const initialState: AdminItemsState = {
  items: [],
  openCount: 0,
  loading: false,
  page: 1,
  lastPage: 1,
  total: 0,
  perPage: 10,
  status: 'open',
};

export const adminItemsSlice = createSlice({
  name: 'adminItems',
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setAdminItemsStatus: (
      state,
      { payload }: PayloadAction<AdminItemStatus | 'all'>,
    ) => {
      state.status = payload;
    },
    setAdminItemsPage: (
      state,
      { payload }: PayloadAction<AdminItemListResponse>,
    ) => {
      state.items = payload.data;
      state.page = payload.meta.current_page;
      state.lastPage = payload.meta.last_page;
      state.total = payload.meta.total;
      state.perPage = payload.meta.per_page;
      state.loading = false;
    },
    setOpenCount: (state, { payload }: PayloadAction<number>) => {
      state.openCount = payload;
    },
    removeItem: (state, { payload }: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== payload);
    },
  },
});

export const { reducer: adminItemsReducer } = adminItemsSlice;
